/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IntegrationUpdateClientPayload = {
    firstName?: string;
    lastName?: string;
    gender?: IntegrationUpdateClientPayload.gender;
    email?: string;
    phoneNumber?: string;
    isActive?: boolean;
    notes?: string;
};
export namespace IntegrationUpdateClientPayload {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

